import { QueryKey } from "@tanstack/react-query";

export const addKeyToQueryResult = <T extends object, Q extends QueryKey>(
  result: T,
  queryKey: Q
): T & { queryKey: Q } => {
  return new Proxy(result as T & { queryKey: Q }, {
    get(target, prop, receiver) {
      if (prop === "queryKey") {
        return queryKey;
      }
      return Reflect.get(target, prop, receiver);
    },
  });
};
